// test469
(469 && 0);
